import * as React from 'react';
import GroupContainer, {GroupContainerProps} from 'containers/GroupContainer';
import {CourseObject, isFree} from 'api/course';
import CourseBuilderContext from '../../CourseBuilderContext';

export type FormContainerProps =
  React.PropsWithChildren<GroupContainerProps<CourseObject>> & {
  /**
   * This flag is responsible for the availability of
   * the setting, in the course, which is free.
    */
  notAvailableForFree?: boolean;
};

/**
 *
 * @param {FormContainerProps} props
 * @return {React.ReactElement<FormContainerProps>}
 * @constructor
 */
export default function FormContainer(
    props: FormContainerProps,
): React.ReactElement<FormContainerProps> {
  const {course} = React.useContext(CourseBuilderContext);

  return (
    <GroupContainer<CourseObject>
      {...props}
      disabled={(props.notAvailableForFree && course) ? (
        isFree(course)
      ) : undefined}
    />
  );
}
